import { IRowNode } from 'ag-grid-community';
import { DeviceAdminSetRemoteSourceResponse } from 'api/actions/device-admin-set-remote-source/device-admin-set-remote-source-response';
import { DeviceRow } from 'components/tables/data/device/types';
import DeviceActions from 'components/tables/data/device/DeviceActions';
import { DeviceQrPairResponse } from 'api/actions/device-qr-pair/device-qr-pair-response';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ node, data }: { node: IRowNode<DeviceRow>; data: DeviceRow }) {
  /**
   * Patches the row after an admin-only remote source reassignment.
   */
  const handleRemoteSourceChange = (response: DeviceAdminSetRemoteSourceResponse) => {
    const currentData = node.data ?? data;

    node.setData({ ...currentData, remoteSource: response.remoteSource, externalId: response.externalId });
  };

  /** Patches the QR fields after pairing without reloading the table. */
  const handleQrPairingChange = (response: DeviceQrPairResponse) => {
    const currentData = node.data ?? data;
    node.setData({ ...currentData, qrId: response.qrId, qrUrl: response.qrUrl });
  };

  return (
    <DeviceActions
      {...data}
      canDiscard={data.canDiscard}
      compactOnTablet
      onStatusChange={(status) => node.setData({ ...(node.data ?? data), status })}
      onRemoteSourceChange={handleRemoteSourceChange}
      onQrPairingChange={handleQrPairingChange}
    />
  );
}
